module.exports = __webpack_public_path__ + "img/banner_info_2.4066dd52.png";